import OurProjectsBanner from './OurProjectsBanner';
export default OurProjectsBanner;
